<template>
  <div class="card padding-card" :class="[disabled ? 'grayscale' : '']">
    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <img style="width: 100%" :src="image" alt="">
      </div>
      <div class="col-lg-6 col-sm-12">
        <h5 class="text-align-center padding-top-h">{{ title }}</h5>
        <div class="book-description">{{ shortDescription }}</div>
        <div
          class="btn btn-success ml-auto"
          :class="[disabled ? 'disabled' : '']"
          @click="onSubmit(book)">
          Download
        </div>
      </div>
    </div>
    <div class="row">
      {{ description }}
    </div>
    <div class="row">

    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    shortDescription: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    onSubmit: {
      type: Function,
      required: true
    },
    book: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .padding-card {
    padding: 10px 35px;
  }
  .text-align-center {
    text-align: center;
  }
  .padding-top-h {
    padding-top: 10px;
  }
  .btn-row {
    width: 100%;
    float: right;
  }
  .grayscale {
    filter: grayscale(100%);
    opacity: .5;
  }
</style>
